import isCommandEnabled from './isCommandEnabled';
import { CommandeLinePanier } from '../../types/commandeLine/commandeLine.def';

export type ProductRebondTest = {
  quantite: number;
  venterebond: boolean;
};

export const getRebondDisabledMessage = (
  commandeLine: CommandeLinePanier[],
  isPublicShop = false
): string | null => {
  if (isPublicShop) return null;
  return (
    !isCommandEnabled(commandeLine) &&
    commandeLine.length > 0 &&
    '* Ce produit ne peut être vendu seul ou en quantité inférieure à 10 unités'
  );
};

export const isEnoughRebondProducts = (
  productRebonds: ProductRebondTest[]
): boolean => {
  let quantityOfProduct = 0;
  productRebonds.forEach(produit => (quantityOfProduct += produit.quantite));
  return quantityOfProduct >= 10;
};

export const isProductRebondValid = (
  commandeLines: CommandeLinePanier[],
  isPublicShop = false
): boolean => {
  if (isPublicShop) return true;
  const parsedCommandeLines: Array<ProductRebondTest> = commandeLines.map(
    line => ({
      quantite: line.quantite,
      venterebond: line.produit.venterebond
    })
  );
  const isOnlyRebondProduct: boolean = parsedCommandeLines.every(
    produit => produit.venterebond === true
  );
  return isOnlyRebondProduct
    ? isEnoughRebondProducts(parsedCommandeLines)
    : true;
};
